import React from 'react';
import { theme } from '../config/theme';

function Breadcrumb({ container, prefix, onNavigate }) {
  const parts = prefix ? prefix.split('/').filter(Boolean) : [];

  return (
    <nav style={styles.container}>
      <span style={styles.link} onClick={() => onNavigate('')}>
        {container.toUpperCase()}
      </span>
      {parts.map((part, index) => {
        const path = parts.slice(0, index + 1).join('/') + '/';
        return (
          <React.Fragment key={path}>
            <span style={styles.separator}>›</span>
            <span
              style={index === parts.length - 1 ? styles.current : styles.link}
              onClick={() => index < parts.length - 1 && onNavigate(path)}
            >{part}</span>
          </React.Fragment>
        );
      })}
    </nav>
  );
}

const styles = {
  container: {
    display: 'flex', alignItems: 'center', gap: '6px',
    padding: '12px 0', fontSize: '13px', flexWrap: 'wrap',
  },
  link: { color: theme.colors.textSecondary, cursor: 'pointer' },
  separator: { color: theme.colors.border, fontSize: '16px' },
  current: { color: theme.colors.textPrimary, fontWeight: '500' },
};

export default Breadcrumb;